module.exports = __webpack_public_path__ + "img/botella_black_1_1.c392e9c3.png";